import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

const BreadcrumbsWrapper = styled('div')({
  marginBottom: 4,
  paddingLeft: 50,
  display: 'flex',
  alignItems: 'center',
  [mediaQuery(600)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});

export default BreadcrumbsWrapper;
